<h2 mat-dialog-title>{{ 'MEETING_SCHEDULER.ATTENDEE_LIST.MANAGE_REGISTRANT_TITLE' | translate }}</h2>
<mat-dialog-content class="table-dialog">
  <glxy-table-container
    #tableContainer
    [columns]="columns$ | async"
    [dataSource]="dataSource"
    [pageSizeOptions]="[25, 50, 100]"
    [pageSize]="25"
    [showSelection]="true"
    [singleSelection]="false"
    (selectionChanged)="onSelectionChanged($event)"
    (searchTermChanged)="onSearchChange($event)"
    [fullWidth]="true"
  >
    <glxy-table-content-header
      [showSort]="false"
      [showActions]="true"
      [showFilters]="true"
      [showFiltersOpen]="false"
      [showColumnArrange]="true"
      [showFiltersApplied]="false"
      [hideActionButton]="false"
      [showSelectedAllCount]="useSelectAll"
      [showSearch]="true"
    >
      <glxy-filter-chips
        [addFiltersHeader]="'MEETING_SCHEDULER.ATTENDEE_LIST.ADD_FILTERS' | translate"
        (filtersChanged)="onFiltersChanged($event)"
        filters-area
      ></glxy-filter-chips>
      <div class="selectAllButtons" optional-select-all>
        <div class="select-all-objects">
          <ng-container *ngIf="!useSelectAll; else selectAllActive">
            <a (click)="handleSelectAll()">
              {{
                'MEETING_SCHEDULER.ATTENDEE_LIST.SELECT_ALL_ATTENDEES'
                  | translate: { totalAttendees: totalAttendees }
              }}
            </a>
          </ng-container>
          <ng-template #selectAllActive>
            <div class="selection-count">
              {{ 'MEETING_SCHEDULER.ATTENDEE_LIST.TOTAL_SELECTED' | translate: { totalSelected: totalAttendees } }}
            </div>
            <a (click)="handleSelectAll()">
              {{ 'MEETING_SCHEDULER.ATTENDEE_LIST.CLEAR_SELECTION' | translate }}
            </a>
          </ng-template>
        </div>
      </div>

      <button mat-menu-item (click)="onDeleteSelected()" [disabled]="selectedAttendees.length === 0">
        <span>{{ 'MEETING_SCHEDULER.ATTENDEE_LIST.REMOVE_ATTENDEES' | translate }}</span>
      </button>
    </glxy-table-content-header>

    <!-- [hidden] is used here to hide the table columns until the table has finished loading data for the first time -->
    <table mat-table [hidden]="(initialLoadingCompleted$ | async) === false">
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <glxy-table-selection></glxy-table-selection>
        </th>
        <td mat-cell *matCellDef="let row">
          <glxy-table-selection [row]="row"></glxy-table-selection>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_SCHEDULER.ATTENDEE_LIST.NAME_LABEL' | translate }}</th>
        <td mat-cell *matCellDef="let attendee" class="name-column">
          <ng-container *ngIf="hasContactId(attendee); else nameOnly">
            <a (click)="navigateToContact(attendee)" class="contact-link">
              {{ attendee.firstName }} {{ attendee.lastName }}
            </a>
          </ng-container>
          <ng-template #nameOnly>
            <span class="name-text"> {{ attendee.firstName }} {{ attendee.lastName }} </span>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_SCHEDULER.ATTENDEE_LIST.EMAIL_LABEL' | translate }}</th>
        <td mat-cell *matCellDef="let attendee" class="email-column">
          {{ attendee.email || '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_SCHEDULER.ATTENDEE_LIST.PHONE_LABEL' | translate }}</th>
        <td mat-cell *matCellDef="let attendee" class="phone-column">
          <span
            [glxyTooltip]="attendee.phoneNumber || ''"
            [glxyTooltipDisabled]="!attendee.phoneNumber"
          >
            {{ attendee.phoneNumber || '—' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="comment">
        <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_SCHEDULER.ATTENDEE_LIST.COMMENTS_LABEL' | translate }}</th>
        <td mat-cell *matCellDef="let attendee" class="comment-column">
          <span
            [glxyTooltip]="attendee.comment && attendee.comment.length > 100 ? attendee.comment : ''"
            [glxyTooltipDisabled]="!attendee.comment || attendee.comment.length <= 100"
            class="comment-text"
          >
            {{ attendee.comment || '—' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let attendee" class="actions-column">
          <button mat-icon-button [matMenuTriggerFor]="actionMenu" class="action-menu-button">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #actionMenu="matMenu" xPosition="before" yPosition="below">
            <button mat-menu-item (click)="onRemoveAttendee(attendee)">
              <span>{{ 'MEETING_SCHEDULER.ATTENDEE_LIST.REMOVE_ATTENDEE' | translate }}</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <glxy-empty-state class="empty-table-container" *ngIf="showEmptyState$ | async">
      <glxy-empty-state-hero>
        <mat-icon class="empty-state-icon">people</mat-icon>
      </glxy-empty-state-hero>
      <glxy-empty-state-title>
        {{ 'MEETING_SCHEDULER.ATTENDEE_LIST.EMPTY_STATE.TITLE' | translate }}
      </glxy-empty-state-title>
      <p>{{ 'MEETING_SCHEDULER.ATTENDEE_LIST.EMPTY_STATE.DESCRIPTION' | translate }}</p>
    </glxy-empty-state>
  </glxy-table-container>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="primary" (click)="onClose()">
    {{ 'MEETING_SCHEDULER.COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
